import { useContext } from 'react';
import { Helmet } from 'react-helmet';
import AppContext from 'AppContext';
import styled from 'styled-components';
import { Nav } from 'components/base/nav';
import PartnerBanner from 'components/pages/about/partnerbanner';
import Signups from 'components/pages/about/signup';
import Header from 'components/pages/homepage/homepageheader';
import Content from 'components/utilities/components/Content';
import HorizontalTimeline from 'components/utilities/components/HorizontalTimeline';
import Slides from 'components/utilities/slides';
import { theme } from 'components/utilities/utils';
import Footer from 'components/views/FooterView';
import ProgramSection from 'components/views/ProgramSection';
import Subheader from 'components/views/Subheader';
import FaqComponent from 'components/views/faq';
import WorkshopsView from 'components/views/workshopsview';

const Section = styled.section`
  text-align: center;
  padding: 0px;
  background: ${(props) => props.theme.colors.white};
  max-width: 1280px;
`;

const Partners = styled(PartnerBanner)`
  // padding: 0px 0 40px 0;
`;

export default function WomenFounders() {
  const { content, programs } = useContext(AppContext);
  return (
    <Section>
      <Helmet>
        <title>Parkdale Centre for Innovation</title>
        <meta
          name="description"
          content="Grow your idea, join a community, get traction, and see your project through at Parkdale Centre"
        />
        <meta property="og:title" content="Parkdale Centre" />
        <meta property="og:image" content="images/previews/incubators.png" />
        <meta
          property="og:url"
          content="https://www.parkdaleinnovates.org/programs"
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Incubate your Startup, Business or Career at Parkdale Centre."
        />
        <meta
          property="og:description"
          content="Grow your idea, get traction, and scale your work at Parkdale Centre. You bring the motivation."
        />
        <meta property="og:image" content="images/previews/incubators.png" />
      </Helmet>
      <Header
        pageName="womenfounders"
        color={
          content.womenfounders.Headers['Header text background color'] ||
          theme.colors.purple4
        }
        nav={<Nav />}
        showNavigation
        showLanguageSelector
      />
      <Subheader
        pageName="womenfounders"
        section="SubHeaders"
        lcolor2="red"
        rcolor1={theme.colors.white}
        borderleft={theme.colors.gray5}
        borderright="transparent"
      />
      <Slides pageName="womenfounders" section="Carousel1" size="joint" />
      <HorizontalTimeline
        pageName="womenfounders"
        listName="Timeline"
        titleName="Hero"
      />
      <WorkshopsView />
      <Content content={programs.womenfounders}>
        <ProgramSection
          color={content.womenfounders.Footer.ThemeColor}
          programName="womenfounders"
        />
      </Content>
      {/* <Team id="team" pageName="Team" /> */}
      {/* <Advisors
        id="advisors"
        folder="advisors"
        pageName="Advisors"
        title="Program Advisors"
        margin="40px auto 0px"
      /> */}
      {/* <Advisors
        id="Fall2020"
        pageName="Fall2020"
        title="2021 Entrepreneurs"
        padding="20px 0px 0px"
        margin="-80px auto 0px"
      />
      <Advisors
        id="Winter2021"
        pageName="Winter2021"
        title=""
        padding="0px 0px 0px"
        margin="-80px auto -40px"
      /> */}
      <Partners
        id="partners"
        title="Program Partners"
        pageName="womenfounders"
        margin="0px auto 0px"
      />
      <FaqComponent pageName="womenfounders" />
      <Signups pageName="womenfounders" />
      <Footer pageName="womenfounders" />
    </Section>
  );
}
